import { Component, ElementRef, ViewChild} from '@angular/core';
import { ResourcesProvider } from '../../providers/resources/resources.provider';
import { ParentEducationMoment } from '../../models/parent-education-moment';
import { Filters, FilterSection, FilterItem } from 'src/app/components/resources-filter/resources-filter.component';
import { plainToClass } from 'class-transformer';
import { Collection } from 'src/app/models/collection';
import { ResourcesBase } from '../resources/resources-base.page';
import { ResourcesCssService } from '../resources/resources-css.service'
import { WindowService } from '../../services/window.service'
import { ResourceStore } from 'src/app/stores/resources.store';

@Component({
  selector: 'app-parent-education',
  templateUrl: './parent-education.page.html',
  styleUrls: ['./parent-education.page.scss'],
})
export class ParentEducationPage extends ResourcesBase<ParentEducationMoment> {

  constructor(element: ElementRef,
              resourcesProvider: ResourcesProvider,
              resourcesCssService: ResourcesCssService,
              windowService: WindowService,
              protected resourceStore: ResourceStore) {
    super(element, resourcesProvider, resourcesCssService, windowService, resourceStore)
  }

  items(): ParentEducationMoment[] {
    return this.resources.parentEducationMoments
  }

  updateFilters() {
    super.updateFilters()

    const itemsTypes = this.itemsTypes(this.items())
    const collections = Collection.collectionsWithTags(this.resources.collections, itemsTypes) // Add collections with tags that match any of the videos

    this.filters = plainToClass(Filters, {
      orMode: true,
      sections: [
        {
          title: 'Participation',
          items: [
            { title: 'Parent/caregiver modeling' },
            { title: 'Setting expectations' },
            { title: 'Making music at home' },
          ],
          allowMultiple: true
        },
        {
          title: 'Curriculum/Philosophy',
          items: [
            { title: 'Rhythm' },
            { title: 'Tonality' },
            { title: 'Instruments & Props' },
            { title: 'Why we do what we do' },
          ],
          allowMultiple: true
        },
        {
          title: 'Music Development',
          items: [
            { title: 'Rhythm Development' },
            { title: 'Tonal Development' },
            { title: 'Audiation' },
            { title: 'Primary Instrument' },
            { title: 'General Music Development' },
          ],
          allowMultiple: true
        },
        {
          title: 'Other',
          items: [
            { title: 'Child & Brain Development' },
            { title: 'Babies' },
            { title: 'Generations' },
            { title: 'Rhythm Kids' },
            { title: 'Classroom Management' },
            { title: 'Demo Classes' },
            { title: 'General Benefits of Music' },
          ],
          allowMultiple: true
        },
        // {
        //   title: 'Collection',
        //   items: collections.map( (collection: Collection) => {
        //     return { title: collection.name, info: collection }
        //   })
        // }
      ],
    })
  }

  itemsMatchingFilters(items: ParentEducationMoment[], filters: Filters): ParentEducationMoment[] {
    return filters.filter(items, (item: ParentEducationMoment, section: FilterSection, filterItem: FilterItem) => {
      return item.typesList().some( (type: string) => type.toLowerCase() === filterItem.title.toLowerCase() )
    })
  }

  itemMatchesSearch(item: ParentEducationMoment, searchString: string): boolean {
    return item.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
      item.description.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
      item.typesList().find( (value: string) => value.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ) != null
  }

  itemTypes(item: ParentEducationMoment): string[] {
    return item.typesList()
  }

}
